import { Job } from '../job/Job';
import { TagStatus } from './TagStatus';

export interface ITag {
  id: string;
  projectId: string;
  name: string;
}

export class Tag implements ITag {
  public id: string;
  public projectId: string;
  public job: Job;
  public collectionId: string;
  public resourceId: string;
  public name: string;
  public exclusions: string[];
  public inverses: string[];
  public children: string[];
  public status: TagStatus;
  public users: Array<String>;
  public roles: Array<String>;

  constructor(projectId: string, id?: string, name?: string, percentageComplete?: number, description?: string,
              collectionId?: string, resourceId?: string, exclusions?: string[],
              inverses?: string[], children?: string[]) {
    this.projectId = projectId;
    this.collectionId = collectionId;
    this.resourceId = resourceId;
    this.id = id;
    this.job = new Job();
    this.job.percentageComplete = percentageComplete;
    this.job.description = description;
    this.name = name;
    this.exclusions = exclusions;
    this.inverses = inverses;
    this.children = children;
  }
}
